import { createCrudModule } from "../crud";

const hasNewBanners = data => typeof File !== "undefined" && (data?.banners || []).some(banner => banner?.file instanceof File);

function appendFormValue(form, key, value) {
  if (value === undefined) return;
  if (value === null) { form.append(key, ""); return; }
  if (Array.isArray(value)) {
    value.forEach((item, index) => appendFormValue(form, `${key}[${index}]`, item));
    return;
  }
  if (typeof value === "object") {
    Object.entries(value).forEach(([childKey, child]) => appendFormValue(form, `${key}[${childKey}]`, child));
    return;
  }
  form.append(key, value);
}

export function campaignRequestBody(data, update = false) {
  const { banners = [], removed_banner_ids = [], removed_session_ids = [], ...fields } = data;
  const content = update ? { ...fields, removed_session_ids } : fields;
  if (!hasNewBanners(data) && !removed_banner_ids.length) return content;
  const form = new FormData();
  if (update) form.append("_method", "PUT");
  Object.entries(content).forEach(([key, value]) => appendFormValue(form, key, value));
  const newBanners = banners.filter(banner => typeof File !== "undefined" && banner?.file instanceof File);
  newBanners.forEach(banner => form.append("banners[]", banner.file));
  removed_banner_ids.forEach(id => form.append("remove_banner_ids[]", id));
  banners.forEach(banner => {
    const reference = banner?.id || (banner?.file ? `new:${newBanners.indexOf(banner)}` : null);
    if (reference !== null) form.append("banner_order[]", reference);
  });
  return form;
}

export function campaignListing(response) {
  const data = response?.data;
  const rows = Array.isArray(data) ? data : data?.data;
  if (!Array.isArray(rows)) throw new Error("Invalid campaign listing response.");
  return { rows, lastPage: data?.last_page ?? response?.meta?.last_page ?? 1 };
}

export default createCrudModule({
  name: "campaigns",
  stateKey: "Campaigns",
  endpoint: "campaigns",
  operations: {
    list: {
      query: ({ page = 1, length = 10, search = "", status = "" } = {}) => Object.fromEntries(
        Object.entries({ paginate: page, size: length, search, status }).filter(([, value]) => value !== "")
      ),
      select: campaignListing,
    },
    details: {},
    create: {
      body: data => campaignRequestBody(data),
    },
    update: {
      method: ({ data }) => hasNewBanners(data) || data?.removed_banner_ids?.length ? "POST" : "PUT",
      body: ({ data }) => campaignRequestBody(data, true),
    },
    delete: {},
    status: {
      method: "PATCH", path: ({ id }) => `campaigns/${encodeURIComponent(id)}/status`, body: ({ status }) => ({ status }),
    },
    publish: {
      method: "POST", path: ({ id }) => `campaigns/${encodeURIComponent(id)}/publish`,
    },
    packageOptions: {
      method: "GET", path: "packages", query: { paginate: 0, size: "" },
      select: response => {
        const rows = Array.isArray(response?.data) ? response.data : response?.data?.data;
        if (!Array.isArray(rows)) throw new Error("Invalid package options response.");
        return rows.map(item => ({ value: String(item.id), label: item.name || item.title }));
      },
    },
  },
});
